import Cookies from 'js-cookie'

// set unique session id that expires when the browser closes
export const getSessionId = () => {
  const existingId = Cookies.get('session_id')
  if (existingId) {
    return existingId
  }

  const sessionId = Math.uuid()
  Cookies.set('session_id', sessionId)
  return sessionId
}



// WEBPACK FOOTER //
// ./src/helpers/getSessionId.js